<template>
  <div class="marcia-view">
    <div class="header">
      <h2>{{ $t('marcia') }}</h2>
      <button class="btn btn-outline-dark btn-sm" @click="goBack">{{ $t('home') }}</button>
    </div>
    
    <div class="grid-container">
      <div 
        v-for="item in marciaItems" 
        :key="item.idAdv" 
        class="marcia-card"
        :style="{ backgroundColor: getStatusColor(item) }"
      >
        <div class="card-content">
          <div class="table-info">
            <span class="table-num">T{{ item.tavolo }}</span>
            <span class="sala-name">{{ item.sala }}</span>
          </div>
          <div class="adv-info">
             <span class="portata">{{ item.portata }}° Portata</span>
             <span class="wait-time">Attesa: {{ item.tempo_di_attesa }}</span>
          </div>
          <div class="elapsed-time">
            Trascorso: {{ getElapsed(item.tm) }} m
          </div>
        </div>
      </div>
      <div v-if="marciaItems.length === 0" class="no-items">
        Nessun tavolo in marcia
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js';

export default {
  name: 'Marcia',
  data() {
    return {
      marciaItems: [],
      refreshInterval: null,
      store
    };
  },
  methods: {
    fetchMarcia() {
      this.axios.post(this.store.path + 'displayMarcia', {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(response => {
        if (response.data && response.data.messaggio) {
          this.marciaItems = response.data.messaggio.sort((a, b) => b.tm - a.tm);
        }
      }).catch(err => {
        console.error("Errore fetch marcia:", err);
      });
    },
    goBack() {
      this.$router.push({ name: 'Gestionale' });
    },
    getElapsed(tm) {
      const now = Math.floor(Date.now() / 1000);
      const elapsed = Math.floor((now - tm) / 60);
      return elapsed;
    },
    getStatusColor(item) {
      const elapsed = this.getElapsed(item.tm);
      
      // Parse wait time (min:sec)
      const parts = item.tempo_di_attesa.split(':');
      const waitMinutes = parseInt(parts[0]) + (parseInt(parts[1]) / 60);
      
      if (elapsed > waitMinutes) {
        return '#ff4d4d'; // Red
      } else if (elapsed > waitMinutes * 0.7) {
        return '#ffa64d'; // Orange
      } else {
        return '#4dff88'; // Green
      }
    }
  },
  mounted() {
    this.fetchMarcia();
    // Refresh every 30 seconds
    this.refreshInterval = setInterval(() => {
      this.fetchMarcia();
    }, 30000);
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
};
</script>

<style scoped>
.marcia-view {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 10px 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.grid-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.marcia-card {
  width: 220px;
  height: 220px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s;
  cursor: default;
}

.marcia-card:hover {
  transform: scale(1.05);
}

.card-content {
  padding: 15px;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.table-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.table-num {
  font-size: 2.8rem;
  font-weight: 800;
}

.sala-name {
  font-size: 1.15rem;
  font-weight: 600;
  opacity: 0.9;
}

.adv-info {
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 1.25rem;
}

.portata {
  display: block;
}

.wait-time {
  font-size: 1.05rem;
}

.elapsed-time {
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 5px;
}

.no-items {
  font-size: 1.2rem;
  color: #666;
  margin-top: 50px;
}
</style>
